'use strict';

import $ from 'jquery';
import { lib } from '../../common/Library';

/**
 * 会社発表履歴ページの動作処理
 */
$(function() {
    //「選択する」が選択されている場合、業種一覧を表示する
    if ($('#sectorTypeSelect').prop('checked')) {
        $('.industry_close').show();
    }

    $('#stock_code2_text').on('click', function() {
        $('#stock_code2').prop('checked', true);
    });
});

$('#checkbox_all').on('click', function() {
    $('.industry_close').hide();
});

$( '#checkbox_select' ).on('click', function() {
    $('.industry_close').show();
});

// 指定銘柄欄バリデーション
function validateStockCode() {
    const val = lib.toHankaku($('#stock_code2_text').val()).trim();
    const regex = /^([A-Za-z0-9]{1,4})(\s+[A-Za-z0-9]{1,4})*$/u;
    const selected = $('input[name="stockCodeType"]:checked').val();

    //「指定銘柄」で検索時にのみ表示
    if (selected === '2') {
        if (val !== '' && !regex.test(val)) {
            lib.jqAlert('指定銘柄エラー', '銘柄コード（英数字4桁）のみ使用できます。');
            return false;
        }
    }
    return true;
}

// 「検索する」リンククリック時
$('#tp_commit_cond').on('click', function(e) {
    e.preventDefault();
    if (validateStockCode()) {
        document.getElementById('search_condition').submit();
    }
});

// Enter押下時
$('#search_condition').on('submit', function(e) {
    if (!validateStockCode()) {
        e.preventDefault();
    }
});